import { render, staticRenderFns } from "./EditPlace.vue?vue&type=template&id=f5b1e1c8&scoped=true"
import script from "./EditPlace.vue?vue&type=script&lang=js"
export * from "./EditPlace.vue?vue&type=script&lang=js"
import style0 from "./EditPlace.vue?vue&type=style&index=0&id=f5b1e1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b1e1c8",
  null
  
)

export default component.exports